// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type LayersSvgrepoComsvgIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function LayersSvgrepoComsvgIcon(props: LayersSvgrepoComsvgIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      version={"1.1"}
      x={"0"}
      y={"0"}
      viewBox={"0 0 54.953 54.953"}
      xmlSpace={"preserve"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",

        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M45.297 21.946l9.656-5.517L27.477.825 0 16.429l9.656 5.517L0 27.429l9.656 5.517L0 38.429l27.477 15.698 27.476-15.698-9.656-5.483 9.656-5.517-9.656-5.483zM27.477 3.125l23.435 13.309-23.435 13.39-23.436-13.39L27.477 3.125zM11.675 23.099l15.802 9.028 15.802-9.028 7.633 4.335-23.435 13.39-23.436-13.39 7.634-4.335zm39.237 15.335l-23.435 13.39-23.436-13.39 7.634-4.335 15.802 9.028 15.802-9.028 7.633 4.335z"
        }
      ></path>
    </svg>
  );
}

export default LayersSvgrepoComsvgIcon;
/* prettier-ignore-end */
